export default __webpack_public_path__ + "static/media/110.5a8f5fd2.jpg";